<template>
  <BaseDialog
    ref="baseDialog"
    modal-id="deleteClassDialog"
    :title="$t('deleteDialog.title', { entity: $t('classes.entity') })"
    :confirm-text="$t('deleteDialog.confirm')"
    confirm-variant="danger"
    :loading="loading"
    @confirm="handleConfirm"
  >
    <template #body>
      <p v-html="$t('deleteDialog.message', { entity: $t('classes.entity'), name: className })"></p>
      <p class="text-danger">{{ $t('deleteDialog.warning') }}</p>
    </template>
  </BaseDialog>
</template>

<script setup>
import { ref, defineEmits, defineExpose } from 'vue';
import BaseDialog from '@/components/common/BaseDialog.vue';

const baseDialog = ref(null);
const loading = ref(false);
const className = ref('');

const openDialog = (name = '') => {
  className.value = name;
  loading.value = false;
  baseDialog.value?.openDialog();
};

const closeDialog = () => {
  baseDialog.value?.closeDialog();
};

const emit = defineEmits(['delete']);

const handleConfirm = async () => {
  loading.value = true;
  try {
    emit('delete');
    closeDialog();
  } finally {
    loading.value = false;
  }
};

defineExpose({ openDialog });
</script>